import { Chip, Tooltip } from '@mui/material';

export interface AutoCreatedChipProps {
  shown: boolean;
}

export default function AutoCreatedChip({ shown }: AutoCreatedChipProps) {
  if (!shown) return null;
  return (
    <Tooltip title="BETHY's extension created this patient record in OA because no match was found at claim time.">
      <Chip size="small" color="warning" variant="outlined" label="Auto-created in OA" />
    </Tooltip>
  );
}
